import { tableFeatures } from '@tanstack/react-table';

export const simpleTableFeatures = tableFeatures({});

export type SimpleTableFeatures = typeof simpleTableFeatures;
